import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useFileExplorerContext } from './useFileExplorerContext';
import { folderKeys } from '../components/FileExplorer/utils/queryKeys';

interface FileExplorerMutationError {
  reason: string;
  description: string;
}

export function useFileExplorerMutation<T>({
  mutationFn, onSuccess,
}: { mutationFn: (args: T) => Promise<unknown>; onSuccess?: (response: unknown) => void }) {
  const { activeFolder } = useFileExplorerContext();
  const queryClient = useQueryClient();

  const queryKey = activeFolder !== null
    ? folderKeys.detail(activeFolder.id)
    : folderKeys.root();

  const mutation = useMutation<unknown, AxiosError<FileExplorerMutationError>, T>({
    mutationFn,
    onSuccess: async (response) => {
      onSuccess?.(response);
      await queryClient.invalidateQueries({ queryKey });
    },
  });

  return mutation;
}
